import { AxiosPromise } from "axios";
import { WartungApi, Wartungsinfo } from "../../../api";
import { BASE_PATH } from "../../../constants/constants";
import { axiosInstance } from "../../../factory/AxiosFactory";

class WartungsinfoService {
  private static _instance: WartungsinfoService;

  private api = new WartungApi(undefined, BASE_PATH, axiosInstance);

  private constructor() {}

  public static get Instance() {
    return this._instance || (this._instance = new this());
  }

  public getWartungsinfo(): AxiosPromise<Wartungsinfo> {
    return this.api.getWartungsinfo();
  }
  
}

export const wartungsinfoService = WartungsinfoService.Instance;

